import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { WifiHealthComponent } from '@app/features/wifi/modules/wifi-health/wifi-health.component';
import { Authority } from '@app/shared/utils/enums';

export const wifiRoutes: Routes = [
    {
        path: 'wifi',
        children: [
            {
                path: '',
                component: WifiHealthComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.LOGIN, Authority.RESTAURANT_VIEW, Authority.UPDATE],
                    reuse: true
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]